import { handleActions } from 'redux-actions'
import { List, Map, Record } from 'immutable'

import { getCompletedActivities, getCompletedProtracks, setCurrentPage } from './actions'
// @ts-ignore
import { COMPLETED_PROTRACKS_PAGINATION } from 'app/constants/pagination'
import { ICompletedActivity, ICompletedLevel, ICompletedProtracks, ICompletedProtracksRecord } from './interface'

export const CompletedLevel = Record<ICompletedLevel>({
  id: null,
  streak: null,
  activities: null,
  name: null,
  proTrackName: null,
  color: null,
  image: null,
  finishDate: null,
  finishedIn: null,
  stoppedDate: null,
  status: null,
  recordId: null,
  userProTrackLevelId: null,
})

export const CompletedActivity = Record<ICompletedActivity>({
  activityId: null,
  actionType: null,
  updatedAt: null,
  previousActionType: null,
  hasStory: null,
  content: {
    activity: {
      activityId: null,
      proQuote: null,
      proQuoteAuthor: null,
      description: null,
      name: null,
    },
  },
})

export const CompletedProtracks = Record<ICompletedProtracks>(
  {
    pending: false,
    pagination: Map({
      count: null,
      perPage: COMPLETED_PROTRACKS_PAGINATION,
      current: 0,
      show: false,
    }),
    levelsList: List([]),
    activitiesList: List([]),
  },
  'CompletedProtracks'
)

const getCompletedProtracksRequest = (state: ICompletedProtracksRecord) => state.set('pending', true)

const getCompletedActivitiesRequest = (state: ICompletedProtracksRecord) => state.set('pending', true)

const handleSetCurrentPage = (state: ICompletedProtracksRecord, { payload }: any) =>
  state.setIn(['pagination', 'current'], payload.current)

const getCompletedProtracksSuccess = (state: ICompletedProtracksRecord, { payload: { data, pagination } }: any) =>
  state
    .set('pending', false)
    .setIn(['pagination', 'count'], pagination.count)
    .setIn(['pagination', 'show'], data.length > COMPLETED_PROTRACKS_PAGINATION)
    .set(
      'levelsList',
      List(
        data.map(
          ({ streakMax, completedCount, ...rest }: any) =>
            new CompletedLevel({
              streak: streakMax,
              activities: completedCount,
              ...rest,
            })
        )
      )
    )

const getCompletedProtracksFail = (state: ICompletedProtracksRecord) => state.set('pending', false)

const getCompletedActivitiesSuccess = (
  state: ICompletedProtracksRecord,
  {
    payload: {
      data: { userActivities, userProTrackLevel },
    },
  }: any
) => {
  return state.set('pending', false).set(
    'activitiesList',
    List(
      userActivities.reduceRight(
        (arr: any, { activityId, actionType, updatedAt, activity, hasStory }: any, i: number, allArr: any) => {
          arr.push(
            new CompletedActivity({
              activityId,
              actionType,
              updatedAt,
              hasStory,
              previousActionType: allArr[i - 1] && allArr[i - 1].actionType,
              content: Map({
                activity: Map({
                  activityId,
                  ...activity,
                }),
                level: {
                  proTrackName: userProTrackLevel && userProTrackLevel.proTrack && userProTrackLevel.proTrack.name,
                  name: userProTrackLevel && userProTrackLevel.name,
                },
              }),
            } as any)
          )
          return arr
        },
        []
      )
    )
  )
}

const getCompletedActivitiesFail = (state: ICompletedProtracksRecord) => state.set('pending', false)

export default handleActions(
  {
    [getCompletedProtracks as any]: getCompletedProtracksRequest,
    [getCompletedProtracks.success as any]: getCompletedProtracksSuccess,
    [getCompletedProtracks.fail as any]: getCompletedProtracksFail,
    [getCompletedActivities as any]: getCompletedActivitiesRequest,
    [getCompletedActivities.success as any]: getCompletedActivitiesSuccess,
    [getCompletedActivities.fail as any]: getCompletedActivitiesFail,
    [setCurrentPage as any]: handleSetCurrentPage,
  },
  new CompletedProtracks()
)
